import { getDomainCfg } from "../core/state";
import { getCurrentViewName } from "../core/views";

export const triggerIntegrationStyles = () => {
  try {
    const viewName = getCurrentViewName();
    const domainCfg = getDomainCfg();
    if (!domainCfg?.viewSettings?.integrationStyles) {
      return;
    }
    const integrationStyles = domainCfg.viewSettings.integrationStyles;
    const integrationStyle = integrationStyles.find(style => style.viewName === viewName);
    console.log('triggerIntegrationStyles', viewName, integrationStyles, integrationStyle);
    if (integrationStyle && integrationStyle.styles) {
      integrationStyle.styles.forEach(style => {
        console.log('integration style', style);
        const element = document.querySelector(style.selector);
        console.log('integration style', style, element);
        if (element && style.action === 'add' && style.className) {
          element.classList.add(style.className);
        } else if (element && style.action === 'remove' && style.className) {
          element.classList.remove(style.className);
        }
      });
    }
  } catch (error) {
    console.error('Error in triggerIntegrationStyles:', error);
  }
}